







import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {Signature} from '@/store/types'

@Component({})
export default class TaskSignaturePreview extends Vue {
  @Getter('signature') public signature!: Signature
}
